import DomParser from '../dom/index'

import NodeTypes from '../share/NodeTypes'

import Diff from './diff'


import IE from './IE'

const XLINK = "http://www.w3.org/1999/xlink",
  XMLNS = "http://www.w3.org/2000/svg"

export default class {
  constructor(svg) {
    this.tree = null
    this.svg = svg

    this.domParser = new DomParser()
  }

  update(svgCode) {
    let tree = this.parse(svgCode)

    if (!this.tree) {
      this.tree = tree
      tree.forEach(desc => this.svg.appendChild(this.solid(desc)))
    } else {
      this.diff(this.tree, tree)
    }
    tree = null
  }

  parse(svgCode) {
    return this.domParser.parse(this.trim(svgCode))
  }

  trim(code) {
    return code.replace(/(<(pre|script|style|textarea)+?<\/\2)|(^|>)\s+|\s+(?=<|$)/g, "$1$3")
  }

  solid(desc) {
    let { type, name, value, children, attributes } = desc
      , node
    switch (type) {
      case NodeTypes.ELEMENT_NODE: {
        node = document.createElementNS(XMLNS, name)
        for (let key in attributes) {
          if (attributes.hasOwnProperty(key)) {
            this.setAttribute(node, key, attributes[key])
          }
        }
        break
      }
      case NodeTypes.COMMENT_NODE: {
        node = document.createComment(value)
        break;
      }

      case NodeTypes.TEXT_NODE: {
        node = document.createTextNode(value)
        break;
      }
    }

    desc.raw = node

    if (children.length) {
      children.forEach(c => node.appendChild(this.solid(c)))
    }
    return node
  }

  diff(oldTree, newTree) {
    this.align(oldTree, newTree, this.svg)
  }

  align(lista, listb, rawParent) {
    // update lista
    if (JSON.stringify(lista) !== JSON.stringify(listb)) {

      let keyLista = this.getKeyList(lista)
        , keyListb = this.getKeyList(listb)

      if (keyLista && keyListb) {
        let edsc = new Diff(keyLista, keyListb).editscript()

        for (let i = 0; i < edsc.length; i++) {
          switch (edsc[i]) {
            case Diff.INSERT: {
              this.insertNodeByIndex(lista, listb[i], i, rawParent)
              break;
            }
            case Diff.DELETE: {
              this.deleteNodeByIndex(lista, i, rawParent)
              edsc.splice(i, 1)
              i--
              break;
            }
            case Diff.REPLACE: {
              this.replaceNodeByIndex(lista, listb[i], i, rawParent)
              break;
            }
            case Diff.NOOP: {
              this.updateNodeByIndex(lista, listb[i], i, rawParent)
              break;
            }
          }
        }
      } else {

        for (let i = 0, j = 0; i < lista.length && j < listb.length; i++ , j++) {
          this.updateNodeByIndex(lista, listb[i], i, rawParent)
        }

        while (listb.length in lista) {
          this.deleteNodeByIndex(lista, lista.length - 1, rawParent)
        }

        while (listb.length > lista.length) {
          this.insertNodeByIndex(lista, listb[lista.length], lista.length, rawParent)
        }
      }
    }
  }

  getKeyList(list) {
    let footprint = {}
      , keys = []

    for (let i = 0; i < list.length; i++) {
      if (!list[i].attributes.id) {
        return null
      }
      if (list[i].attributes.id in footprint) {
        return null
      }
      keys.push(list[i].attributes.id)
    }
    return keys
  }

  insertNodeByIndex(oldTree, newNode, index, rawParent) {
    if (!newNode.raw) {
      newNode.raw = this.solid(newNode)
    }

    rawParent.insertBefore(newNode.raw, index in oldTree ? oldTree[index].raw : null)
    oldTree.splice(index, 0, newNode)
  }

  deleteNodeByIndex(oldTree, index, rawParent) {
    rawParent.removeChild(oldTree.splice(index, 1)[0].raw)
  }

  replaceNodeByIndex(oldTree, newNode, index, rawParent) {
    if (!newNode.raw) {
      newNode.raw = this.solid(newNode)
    }
    rawParent.replaceChild(newNode.raw, oldTree.splice(index, 1, newNode)[0].raw)
  }

  hasMarkAttr(el) {
    if ("marker-end" in el.attributes) {
      return true
    }

    if ("marker-start" in el.attributes) {
      return true
    }

    if ("marker" in el.attributes) {
      return true
    }
  }

  shouldReplace(oldNode, newNode) {
    if (oldNode.type !== newNode.type) {
      return true;
    }
    if (oldNode.type === newNode.type) {
      if (oldNode.type === NodeTypes.ELEMENT_NODE) {
        if (oldNode.name !== newNode.name) {
          return true
        }
        if (IE && (this.hasMarkAttr(oldNode) || this.hasMarkAttr(newNode))) {
          return true
        }
      } else if (oldNode.value !== newNode.value) {
        return true;
      }
    }

    return false;
  }

  updateNodeByIndex(oldTree, newNode, index, rawParent) {
    if (JSON.stringify(oldTree[index]) !== JSON.stringify(newNode)) {

      if (this.shouldReplace(oldTree[index], newNode)) {
        this.replaceNodeByIndex(oldTree, newNode, index, rawParent)
        return;
      }

      if (oldTree[index].type === NodeTypes.ELEMENT_NODE) {
        this.diffAttributes(oldTree[index], newNode);

        this.align(oldTree[index].children, newNode.children, oldTree[index].raw);
      }
    }
  }

  diffAttributes(oldNode, newNode) {
    for (let newAttrName in newNode.attributes) {
      if (newNode.attributes.hasOwnProperty(newAttrName)) {
        // check inserted attributes 
        if (!(newAttrName in oldNode.attributes)) {
          oldNode.attributes[newAttrName] = newNode.attributes[newAttrName]
          this.setAttribute(oldNode.raw, newAttrName, newNode.attributes[newAttrName])
        } else {
          // check updated attributes 
          if (oldNode.attributes[newAttrName] !== newNode.attributes[newAttrName]) {
            oldNode.attributes[newAttrName] = newNode.attributes[newAttrName]
            this.setAttribute(oldNode.raw, newAttrName, newNode.attributes[newAttrName])
          }
        }
      }
    }

    for (let oldAttrName in oldNode.attributes) {
      if (oldNode.attributes.hasOwnProperty(oldAttrName)) {
        if (!(oldAttrName in newNode.attributes)) {
          delete oldNode.attributes[oldAttrName]
          this.removeAttribute(oldNode.raw, oldAttrName)
        }
      }
    }
  }

  setAttribute(el, attrName, attrValue) {
    if (attrName.substring(0, 6) === "xlink:") {
      el.setAttributeNS(XLINK, attrName.substring(6), attrValue)
    } else if (attrName.substring(0, 4) === "xml:") {
      el.setAttributeNS(XMLNS, attrName.substring(4), attrValue)
    } else {
      el.setAttribute(attrName, attrValue)
    }
  }

  removeAttribute(el, attrName) {
    if (attrName.substring(0, 6) === "xlink:") {
      el.removeAttributeNS(XLINK, attrName.substring(6))
    } else if (attrName.substring(0, 4) === "xml:") {
      el.removeAttributeNS(XMLNS, attrName.substring(4))
    } else {
      el.removeAttribute(attrName)
    }
  }

  destroy() {
    this.tree = null
    this.svg = null
  }
}



// WEBPACK FOOTER //
// ./src/common/components/process-editor/modules/dinnerSvg/svgd/index.js